"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MainNav = void 0;
var React = _interopRequireWildcard(require("react"));
var Popover = _interopRequireWildcard(require("@radix-ui/react-popover"));
var _productIcon = require("../product-icon");
var _logo = _interopRequireDefault(require("./logo.svg"));
require("material-symbols");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var apps = {
  Projects: {
    url: {
      dev: "https://app.pentatonic.com/dev",
      staging: "https://app.pentatonic.com/training",
      demo: "https://app.pentatonic.com/demo",
      production: "https://app.pentatonic.com"
    },
    icon: "rocket_launch",
    position: 1
  },
  "Circularity Calculator": {
    url: {
      dev: "https://circularity-calculator.pentatonic.com/dev",
      staging: "https://circularity-calculator.pentatonic.com/training",
      demo: "https://circularity-calculator.pentatonic.com/demo",
      production: "https://circularity-calculator.pentatonic.com"
    },
    icon: "calculate",
    position: 2
  },
  "Materials Sourcing": {
    url: {
      dev: "https://material-sourcing-dev.pentatonic.com",
      staging: "https://material-sourcing-demo.pentatonic.com",
      demo: "https://material-sourcing-demo.pentatonic.com",
      production: "https://material-sourcing.pentatonic.com"
    },
    icon: "conveyor_belt",
    position: 3
  },
  "Take-back Program": {
    url: {
      dev: "https://decommissioning-dev.pentatonic.com",
      staging: "https://decommissioning-dev.pentatonic.com",
      demo: "https://decommissioning-demo.pentatonic.com",
      production: "https://decommissioning.pentatonic.com"
    },
    icon: "box",
    position: 4
  },
  "Legislation Tracker": {
    url: {
      dev: "https://legislation-dev.pentatonic.com",
      staging: "https://legislation-dev.pentatonic.com",
      demo: "https://legislation-demo.pentatonic.com",
      production: "https://legislation.pentatonic.com"
    },
    icon: "other_admission",
    position: 5
  }
};
var MainNav = exports.MainNav = function MainNav(_ref) {
  var _user$notifications;
  var hideSignIn = _ref.hideSignIn,
    user = _ref.user,
    AvatarMenuSlot = _ref.AvatarMenuSlot,
    _ref$handleSignIn = _ref.handleSignIn,
    handleSignIn = _ref$handleSignIn === void 0 ? function () {} : _ref$handleSignIn,
    _ref$handleSignOut = _ref.handleSignOut,
    handleSignOut = _ref$handleSignOut === void 0 ? function () {} : _ref$handleSignOut,
    appName = _ref.appName,
    _ref$env = _ref.env,
    env = _ref$env === void 0 ? "production" : _ref$env;
  return /*#__PURE__*/React.createElement("div", {
    className: "flex px-6 py-4 items-center items-center justify-center gap-4 border-b border-blue-50"
  }, (user === null || user === void 0 ? void 0 : user.orgId) && /*#__PURE__*/React.createElement(Popover.Root, null, /*#__PURE__*/React.createElement(Popover.Trigger, null, /*#__PURE__*/React.createElement("img", {
    src: "".concat(process.env.REACT_APP_URI_BASE_PATH, "/assets/organizations/").concat(user.orgId, "/logo.png"),
    alt: user.orgNiceName,
    className: "w-8 rounded"
  })), /*#__PURE__*/React.createElement(Popover.Portal, null, /*#__PURE__*/React.createElement(Popover.Content, {
    className: "rounded shadow-3xl p-2 bg-white min-w-[12rem] z-20",
    collisionPadding: 16,
    sideOffset: 8
  }, /*#__PURE__*/React.createElement("ul", {
    className: "flex flex-col gap-1"
  }, /*#__PURE__*/React.createElement("li", {
    className: "text-sm p-2 text-stone-800 font-medium"
  }, "Workspaces"), user.siblingOrgs.map(function (_ref2) {
    var orgId = _ref2.id,
      name = _ref2.name,
      niceName = _ref2.niceName;
    return /*#__PURE__*/React.createElement("li", {
      key: orgId
    }, /*#__PURE__*/React.createElement("button", {
      onClick: function onClick() {
        return window.location.assign("https://".concat(name, ".pentatonic.com").concat(process.env.REACT_APP_URI_BASE_PATH));
      },
      className: "flex p-2 w-full items-center gap-3 text-left text-sm text-stone-800 rounded-sm hover:bg-stone-50 hover:font-medium ".concat(orgId === user.orgId ? "bg-stone-50" : "")
    }, /*#__PURE__*/React.createElement("img", {
      src: "/assets/organizations/".concat(orgId, "/logo.png"),
      alt: niceName,
      className: "w-4 h-4 rounded"
    }), /*#__PURE__*/React.createElement("div", {
      className: orgId === user.orgId ? "font-medium" : ""
    }, niceName), orgId === user.orgId && /*#__PURE__*/React.createElement("i", {
      className: "material-symbols-rounded text-xl flex grow justify-end leading-none"
    }, "check")));
  }), user.isInternal && /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("button", {
    onClick: handleSignOut,
    className: "flex p-2 w-full items-center gap-3 text-left text-sm text-stone-400 rounded-sm hover:bg-stone-50 hover:font-medium"
  }, "Switch organisation")))))), /*#__PURE__*/React.createElement("img", {
    src: _logo["default"],
    alt: "Pentatonic logo",
    className: "w-[10rem]"
  }), user && /*#__PURE__*/React.createElement(Popover.Root, null, /*#__PURE__*/React.createElement(Popover.Trigger, {
    asChild: true
  }, /*#__PURE__*/React.createElement("button", {
    className: "flex"
  }, /*#__PURE__*/React.createElement("i", {
    className: "material-symbols-rounded text-xxl leading-none"
  }, "apps"))), /*#__PURE__*/React.createElement(Popover.Portal, null, /*#__PURE__*/React.createElement(Popover.Content, {
    className: "rounded shadow-3xl p-2 bg-white min-w-[12rem] z-20",
    collisionPadding: 16,
    sideOffset: 8
  }, /*#__PURE__*/React.createElement("ul", {
    className: "flex flex-col gap-1"
  }, /*#__PURE__*/React.createElement("li", {
    className: "text-sm p-2 text-stone-800 font-medium"
  }, "Switch to"), Object.entries(apps).sort(function (_ref3, _ref4) {
    var _ref5 = _slicedToArray(_ref3, 2),
      a = _ref5[1].position;
    var _ref6 = _slicedToArray(_ref4, 2),
      b = _ref6[1].position;
    return a > b ? 1 : -1;
  }).map(function (_ref7) {
    var _ref8 = _slicedToArray(_ref7, 2),
      key = _ref8[0],
      _ref8$ = _ref8[1],
      icon = _ref8$.icon,
      url = _ref8$.url;
    return /*#__PURE__*/React.createElement("li", {
      key: key
    }, /*#__PURE__*/React.createElement("a", {
      href: url[env],
      className: "flex p-2 w-full items-center gap-3 text-left text-sm text-stone-800 rounded-sm cursor-pointer min-w-[18rem] hover:bg-stone-50 hover:font-medium group ".concat(key === appName && "bg-stone-50")
    }, /*#__PURE__*/React.createElement(_productIcon.ProductIcon, {
      icon: icon
    }), /*#__PURE__*/React.createElement("div", {
      className: "font-medium"
    }, key)));
  }))))), apps[appName] && /*#__PURE__*/React.createElement("div", {
    className: "flex gap-2 items-center"
  }, /*#__PURE__*/React.createElement(_productIcon.ProductIcon, {
    icon: apps[appName].icon
  }), /*#__PURE__*/React.createElement("div", {
    className: "hidden md:block"
  }, appName)), /*#__PURE__*/React.createElement("div", {
    className: "ml-auto"
  }, user !== null && user !== void 0 && user.name ? /*#__PURE__*/React.createElement(Popover.Root, null, /*#__PURE__*/React.createElement(Popover.Trigger, {
    className: "flex gap-2 text-sm items-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "relative flex"
  }, /*#__PURE__*/React.createElement("img", {
    src: user.avatar,
    alt: user.name,
    className: "w-6 h-6 rounded-full"
  }), Boolean(user === null || user === void 0 || (_user$notifications = user.notifications) === null || _user$notifications === void 0 ? void 0 : _user$notifications.length) && /*#__PURE__*/React.createElement("div", {
    className: "w-2.5 h-2.5 bg-red-600 rounded-full border border-solid border-white absolute right-[-1px] top-[-1px]"
  })), /*#__PURE__*/React.createElement("div", null, user.name)), /*#__PURE__*/React.createElement(Popover.Portal, null, /*#__PURE__*/React.createElement(Popover.Content, {
    className: "rounded shadow-3xl p-2 bg-white min-w-[16rem] z-20",
    collisionPadding: 16,
    sideOffset: 8,
    align: "start"
  }, /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", {
    className: "text-sm p-2 text-stone-800 font-medium"
  }, user.email), AvatarMenuSlot, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("button", {
    onClick: handleSignOut,
    className: "flex p-2 w-full items-center gap-3 text-left text-sm text-stone-800 rounded-sm hover:bg-stone-50 hover:font-medium"
  }, "Log out")))))) : !hideSignIn && /*#__PURE__*/React.createElement("button", {
    className: "bg-blue-700 rounded-lg px-4 py-2 text-white text-sm font-medium flex gap-3 items-center justify-center min-h-[2.25rem] hover:bg-blue-800 disabled:bg-stone-200",
    onClick: handleSignIn
  }, /*#__PURE__*/React.createElement("i", {
    className: "material-symbols-rounded text-xl flex grow justify-end leading-none"
  }, "person_outline"), /*#__PURE__*/React.createElement("div", null, "Sign in"))));
};